module.exports = __webpack_public_path__ + "img/88.maintenance.0a9d4574.svg";